import Search from "../../MainContent/Search/Search";
import Marquee from "../../Marquee/Marquee"

const Constitutions = () => {
    return (
        <div className="container">
            <Search />
            <h4 class="pb-4 pt-4 mb-4  ">
                Конститутсияи Ҷумҳурии Тоҷикистон
            </h4>
            <div className="">
                <div className="col-md-12 ">
                    Конститутсияи Ҷумҳурии Тоҷикистон 6 ноябри соли 1994 дар раъйпурсии умумихалқӣ қабул карда шуд.
                    26 сентябри соли 1999, 22 июни соли 2003 ва 22 майи соли 2016 бо тариқи раъйпурсии умумихалқӣ ба он тағйиру иловаҳо ворид карда шудаанд.
                </div>
                <div className="p-5 " style={{ "display": "flex", "justify-content": "center" }} >
                    <img src="https://maorif.tj/storage/posts/April2018/Qa2mcOGeIyBvy6XqbTbR.jpg"></img>
                </div>
                <p className="text-center" >КОНСТИТУТСИЯИ ҶУМҲУРИИ ТОҶИКИСТОН</p>
                <p className="text-center"> МО, ХАЛҚИ ТОҶИКИСТОН,</p>
                <span>
                    қисми ҷудонашавандаи ҷомеаи ҷаҳон буда, <br />
                    худро дар назди наслҳои гузашта, ҳозира ва оянда масъул ва вазифадор дониста,<br />
                    таъмини соҳибихтиёрии давлати худ ва рушду камоли онро дарк намуда,<br />
                    озодӣ ва ҳуқуқи шахсро муқаддас шумурда,<br />
                    баробарҳуқуқӣ ва дӯстии тамоми миллату халқиятҳоро эътироф карда,<br />
                    бунёди ҷомеаи адолатпарварро вазифаи худ қарор дода,<br />
                </span>
                <p className="text-center p-4">ҲАМИН КОНСТИТУТСИЯРО ҚАБУЛ ВА ЭЪЛОН  МЕНАМОЕМ.</p>
                <p className="text-center ">Боби  якум</p>
                <p className="text-center">АСОСҲОИ СОХТОРИ КОНСТИТУТСИОНӢ</p>
                <p >Моддаи 1 </p>

                Ҷумҳурии Тоҷикистон давлати соҳибихтиёр, демократӣ, ҳуқуқбунёд, дунявӣ ва ягона мебошад.<br />

                Шакли идораи Ҷумҳурии Тоҷикистон президентӣ мебошад.<br />

                Тоҷикистон давлати иҷтимоӣ буда, барои ҳар як инсон шароити зиндагии арзанда ва инкишофи озодонаро фароҳам меорад.<br />

                Ҷумҳурии Тоҷикистон ва Тоҷикистон ҳаммаъноянд.<br />

                <p className="">Моддаи 2 </p>

                Забони давлатии Тоҷикистон забони тоҷикӣ аст.<br />

                Забони русӣ ҳамчун забони муоширати байни миллатҳо амал мекунад.<br />

                Ҳамаи миллатҳо ва халқиятҳое, ки дар ҳудуди ҷумҳурӣ зиндагӣ мекунанд, ҳуқуқ доранд аз забони модариашон озодона истифода кунанд.<br />

                <p>Моддаи 3 </p>

                Рамзҳои давлатии Тоҷикистон Парчам, Нишон ва Суруди Миллӣ аст.<br />

                <p>Моддаи 4 </p>

                Пойтахти Тоҷикистон шаҳри Душанбе аст.<br />

                <p>Моддаи 5 </p>

                Инсон, ҳуқуқ ва озодиҳои ӯ арзиши олӣ мебошанд.<br />

                Ҳаёт, қадр, номус ва дигар ҳуқуқҳои фитрии инсон дахлнопазиранд.<br />

                Ҳуқуқу озодиҳои инсон ва шаҳрвандро давлат эътироф, риоя ва ҳифз менамояд.<br />

                <p>Моддаи 6 </p>

                Дар Тоҷикистон халқ баёнгари соҳибихтиёрӣ ва сарчашмаи ягонаи ҳокимияти давлатӣ буда, онро бевосита ва ё ба воситаи вакилони худ амалӣ мегардонад.<br />

                Ифодаи олии бевоситаи ҳокимияти халқ раъйпурсии умумихалқӣ ва интихобот аст.<br />

                Халқи Тоҷикистонро сарфи назар аз миллаташон шаҳрвандони Тоҷикистон ташкил менамоянд.<br />

                Ҳеҷ як иттиҳодияи ҷамъиятӣ, ҳизбҳои сиёсӣ, гурӯҳи одамон ва ё фарде ҳуқуқ надорад, ки ҳокимияти давлатиро ғасб намояд.<br />

                Ғасби ҳокимият ва ё тасарруфи салоҳияти он манъ аст.<br />

                Аз номи тамоми халқи Тоҷикистон фақат Президент, Маҷлиси миллӣ ва Маҷлиси намояндагони Маҷлиси Олии Ҷумҳурии Тоҷикистон дар ҷаласаи якҷояи худ ҳуқуқи сухан гуфтан доранд.<br />

                <p>Моддаи 7 </p>

                Ҳудуди Тоҷикистон тақсимнашаванда ва дахлнопазир мебошад.<br />

                Тоҷикистон аз Вилояти Мухтори Кӯҳистони Бадахшон, вилоятҳо, шаҳрҳо, ноҳияҳо, шаҳракҳо ва деҳаҳо иборат аст.<br />

                Соҳибихтиёрӣ, истиқлолият ва тамомияти арзии Тоҷикистонро давлат таъмин менамояд. Тарғиб ва амалиёти ҷудоиандозӣ, ки ягонагии давлатро халалдор мекунад, манъ аст.<br />

                Тартиби таъсис ва тағйири воҳидҳои маъмурию ҳудудиро қонуни конститутсионӣ танзим менамояд.<br />

                <p>Моддаи 8 </p>

                Дар Тоҷикистон ҳаёти ҷамъиятӣ дар асоси равияҳои гуногуни сиёсӣ ва мафкуравӣ инкишоф меёбад.<br />

                Мафкураи ҳеҷ як ҳизб, иттиҳодияи ҷамъиятӣ, динӣ, ҳаракат ва гурӯҳе наметавонад ба ҳайси мафкураи давлатӣ эътироф шавад.<br />

                Иттиҳодияҳои ҷамъиятӣ ва ҳизбҳои сиёсӣ дар доираи Конститутсия ва қонунҳо таъсис меёбанд ва амал мекунанд.<br />

                Иттиҳодияҳои динӣ аз давлат ҷудо буда, ба корҳои давлатӣ мудохила карда наметавонанд.<br />

                Таъсис ва фаъолияти иттиҳодияҳои ҷамъиятӣ ва ҳизбҳои сиёсие, ки нажодпарастӣ, миллатгароӣ, хусумат, бадбинии иҷтимоӣ ва мазҳабиро тарғиб мекунанд ва ё барои бо зӯрӣ сарнагун кардани сохтори конститутсионӣ ва ташкили гурӯҳҳои мусаллаҳ даъват менамоянд, манъ аст.<br />

                Дар Тоҷикистон фаъолияти ҳизбҳои сиёсии дигар давлатҳо, таъсиси ҳизбҳои хусусияти миллӣ ва динидошта, инчунин маблағгузории ҳизбҳои сиёсӣ аз ҷониби давлатҳо ва созмонҳои хориҷӣ, шахсони ҳуқуқӣ ва шаҳрвандони хориҷӣ манъ аст.<br />

                <p>Моддаи 9 </p>

                Ҳокимияти давлатӣ дар асоси таҷзияи он ба ҳокимияти қонунгузор, иҷроия ва судӣ амалӣ мегардад.<br />

                <p>Моддаи 10 </p>

                Конститутсияи Тоҷикистон эътибори олии ҳуқуқӣ дорад ва меъёрҳои он мустақиман амал мекунанд. Қонунҳо ва дигар санадҳои ҳуқуқие, ки хилофи Конститутсияанд, эътибори ҳуқуқӣ надоранд.<br />

                Давлат ва ҳамаи мақомоти он, шахсони мансабдор, шаҳрвандон ва иттиҳодияҳои онҳо вазифадоранд Конститутсия ва қонунҳои ҷумҳуриро риоя ва иҷро намоянд.<br />

                Санадҳои ҳуқуқии байналмилалие, ки Тоҷикистон онҳоро эътироф кардааст, қисми таркибии низоми ҳуқуқии ҷумҳуриро ташкил медиҳанд. Агар қонунҳои ҷумҳурӣ ба санадҳои ҳуқуқии байналмилалии эътирофшуда мутобиқат накунанд, меъёрҳои санадҳои байналмилалӣ амал мекунанд.<br />

                Қонунҳо ва санадҳои ҳуқуқии байналмилалие, ки Тоҷикистон эътироф кардааст, пас аз интишори расмӣ амал мекунанд.<br />

                <p>Моддаи 11 </p>

                Тоҷикистон сиёсати сулҳҷӯёнаро ба амал татбиқ намуда, соҳибихтиёрӣ ва истиқлолияти дигар давлатҳои ҷаҳонро эҳтиром менамояд ва муносибатҳои хориҷиро дар асоси меъёрҳои байналмилалӣ муайян мекунад.<br />

                Ташвиқоти ҷанг манъ аст.<br />

                Тоҷикистон вобаста ба манфиатҳои олии халқ метавонад ба иттиҳодияҳо ва ташкилотҳои байналмилалӣ дохил шавад, аз онҳо барояд, бо кишварҳои хориҷӣ робита намояд.<br />

                Давлат бо ҳамватанони берунмарзӣ ҳамкорӣ мекунад.<br />

                <p>Моддаи 12 </p>

                Асоси иқтисодиёти Тоҷикистонро шаклҳои гуногуни моликият ташкил медиҳанд.<br />

                Давлат фаъолияти озоди иқтисодӣ, соҳибкорӣ, баробарҳуқуқӣ ва ҳифзи ҳуқуқии ҳамаи шаклҳои моликият, аз ҷумла моликияти хусусиро кафолат медиҳад.<br />

                <p>Моддаи 13 </p>

                Замин, сарватҳои зеризаминӣ, об, фазои ҳавоӣ, олами набототу ҳайвонот ва дигар боигарии табиӣ моликияти истисноии давлат мебошанд ва давлат истифодаи самараноки онҳоро ба манфиати халқ кафолат медиҳад.<br />

                <p className="text-center ">Боби дуюм</p>
                <p className="text-center">ҲУҚУҚ, ОЗОДӢ, ВАЗИФАҲОИ АСОСИИ ИНСОН ВА ШАҲРВАНД</p>

                <p>Моддаи 14 </p>

                Ҳуқуқу озодиҳои инсон ва шаҳрванд ба воситаи Конститутсия, қонунҳои ҷумҳурӣ ва санадҳои ҳуқуқии байналмилалие, ки аз тарафи Тоҷикистон эътироф шудаанд, ҳифз мегарданд.<br />

                Ҳуқуқ ва озодиҳои инсон ва шаҳрванд бевосита амалӣ мешаванд. Онҳо мақсад, мазмун ва татбиқи қонунҳо, фаъолияти ҳокимияти қонунгузор, иҷроия, мақомоти маҳаллии ҳокимияти давлатӣ ва худидоракуниро муайян мекунанд ва ба воситаи ҳокимияти судӣ таъмин мегарданд.<br />

                Маҳдуд кардани ҳуқуқу озодиҳои инсон ва шаҳрванд танҳо ба мақсади таъмини ҳуқуқ ва озодии дигарон, тартиботи ҷамъиятӣ, ҳимояи асосҳои сохтори конститутсионӣ, амнияти давлат, мудофиаи мамлакат, ахлоқи ҷомеа, сиҳатии аҳолӣ ва тамомияти арзии ҷумҳурӣ раво дониста мешавад.<br />

                <p>Моддаи 15 </p>

                Шаҳрванди Ҷумҳурии Тоҷикистон шахсе ҳисоб меёбад, ки дар рӯзи қабули Конститутсия шаҳрванди Ҷумҳурии Тоҷикистон буд ё мутобиқи қонунгузории Ҷумҳурии Тоҷикистон ё шартномаҳои байналмилалии Тоҷикистон шаҳрвандии Ҷумҳурии Тоҷикистонро соҳиб шуда бошад.<br />

                Мансубияти шаҳрванди Тоҷикистон ба шаҳрвандии давлати дигар эътироф намешавад, ба истиснои мавридҳое, ки дар қонун ё шартномаҳои байнидавлатии Тоҷикистон нишон дода шудааст.<br />

                Тартиби соҳиб шудан ва қатъ гардидани шаҳрвандии Ҷумҳурии Тоҷикистонро қонуни конститутсионӣ танзим менамояд.<br />

                <p>Моддаи 16 </p>

                Шаҳрванди Тоҷикистон дар хориҷи кишвар таҳти ҳимояи давлат мебошад. Ҳеҷ як шаҳрванди ҷумҳуриро ба давлати хориҷӣ супурдан мумкин нест. Супурдани ҷинояткор ба давлати хориҷӣ дар асоси шартномаи тарафайн ҳал мешавад.<br />

                Шаҳрванди хориҷӣ ва шахси бешаҳрванд аз ҳуқуқ ва озодиҳои муқарраргардида истифода мебаранд ва баробари шаҳрванди Тоҷикистон вазифа ва масъулият доранд, ба истиснои ҳолатҳое, ки қонун пешбинӣ намудааст.<br />

                Тоҷикистон ба шаҳрвандони хориҷие, ки гирифтори вайронкунии ҳуқуқи инсон гаштаанд, метавонад паноҳгоҳи сиёсӣ диҳад.<br />

                <p>Моддаи 17 </p>

                Ҳама дар назди қонун ва суд баробаранд. Давлат ба ҳар кас, қатъи назар аз миллат, нажод, ҷинс, забон, эътиқоди динӣ, мавқеи сиёсӣ, вазъи иҷтимоӣ, таҳсил ва молу мулк, ҳуқуқу озодиҳоро кафолат медиҳад.<br />

                Мардон ва занон баробарҳуқуқанд.<br />

                <p>Моддаи 18 </p>

                Ҳар кас ҳуқуқ ба ҳаёт дорад.<br />

                Ҳеҷ кас аз ҳаёт маҳрум карда намешавад, ба истиснои ҳукми суд барои ҷинояти махсусан вазнин.<br />

                Дахлнопазирии шахсро давлат кафолат медиҳад. Ба ҳеҷ кас шиканҷа, ҷазо ва муносибати ғайриинсонӣ раво дида намешавад. Мавриди озмоиши маҷбурии тиббӣ ва илмӣ қарор додани инсон манъ аст.<br />

                <p>Моддаи 19 </p>

                Ҳар кас кафолати ҳифзи судӣ дорад. Ҳар шахс ҳуқуқ дорад талаб намояд, ки парвандаи ӯро суди босалоҳият, мустақил ва беғараз, ки тибқи қонун таъсис ёфтааст, баррасӣ намояд.<br />

                Ҳеҷ касро бе асоси қонунӣ дастгир, ҳабс кардан мумкин нест. Ҳар шахс аз лаҳзаи дастгир шудан метавонад аз ёрии адвокат истифода кунад.<br />

                <p>Моддаи 20 </p>

                Ҳеҷ кас то эътибори қонунӣ пайдо кардани ҳукми суд дар содир кардани ҷиноят гунаҳгор дониста намешавад.<br />

                Ҳеҷ кас баъди гузаштани муҳлати таъқиби ҷиноятӣ, инчунин барои содир кардани рафторе, ки ҳангоми воқеъ шуданаш ҷиноят ҳисоб намеёфт, ба ҷавобгарӣ кашида намешавад. Барои як ҷиноят ҳеҷ кас такроран ҷазо намебинад.<br />

                Қонуне, ки баъд аз содир шудани рафтори ғайриқонунии шахс қабул шудааст ва он ҷазои шахсро вазнин мекунад, қувваи бозгашт надорад. Агар баъд аз содир шудани рафтори ғайриқонунӣ барои он ҷазо пешбинӣ нашуда бошад ва ё ҷазои сабук пешбинӣ шуда бошад, қонуни нав амал мекунад.<br />

                Мусодираи пурраи молу мулки шахси маҳкумшуда манъ аст.<br />

                <p>Моддаи 21 </p>

                Ҳуқуқи ҷабрдидаро қонун ҳифз мекунад. Давлат ҳифзи судӣ ва ҷуброни зарарро барои ҷабрдида кафолат медиҳад.<br />

                <p>Моддаи 22 </p>

                Манзили шахс дахлнопазир аст.<br />

                Ба манзили шахс зӯран даромадан ва касеро аз манзил маҳрум кардан манъ аст, ба истиснои мавридҳое, ки қонун муқаррар кардааст.<br />

                <p>Моддаи 23 </p>

                Маҳрамияти мукотиба, суҳбатҳои телефонӣ, муросилот ва мухобироти шахс таъмин карда мешавад, ба истиснои мавридҳое, ки дар қонун нишон дода шудааст.<br />

                Дар бораи ҳаёти шахсии инсон бе розигии ӯ ҷамъ намудан, нигоҳ доштан, истифода ва паҳн кардани маълумот манъ аст.<br />

                <p>Моддаи 24 </p>

                Шаҳрванд ба мусофират, интихоби озоди маҳалли зист, тарки ҷумҳурӣ ва бозгашт ба он ҳуқуқ дорад.<br />

                <p>Моддаи 25 </p>

                Мақомоти давлатӣ, иттиҳодияҳои ҷамъиятӣ, ҳизбҳои сиёсӣ ва шахсони мансабдор вазифадоранд ба ҳар кас имконияти пайдо намудан ва шинос шуданро ба ҳуҷҷатҳое, ки ба ҳуқуқ ва манфиати ӯ дахл доранд, таъмин намоянд, ба истиснои ҳолатҳое, ки қонун муайян кардааст.<br />

                <p>Моддаи 26 </p>

                Ҳар кас ҳуқуқ дорад муносибати худро нисбат ба дин мустақилона муайян намояд, алоҳида ва ё якҷоя бо дигарон динеро пайравӣ намояд ва ё пайравӣ накунад, дар маросим ва расму оинҳои динӣ иштирок намояд.<br />

                <p>Моддаи 27 </p>

                Шаҳрванд ҳуқуқ дорад дар ҳаёти сиёсӣ ва идораи давлатӣ бевосита ва ё ба воситаи вакилонаш иштирок намояд.<br />

                Шаҳрвандон ба хидмати давлатӣ ҳуқуқи баробар доранд.<br />

                Шаҳрванд аз синни 18 ҳуқуқи дар раъйпурсӣ иштирок кардан, интихоб намудан, инчунин аз синни муқаррарнамудаи Конститутсия, қонунҳои конститутсионӣ ва қонунҳо ҳуқуқи интихоб шуданро дорад.<br />

                Шаҳрвандоне, ки аз тарафи суд ғайри қобили амал дониста шудаанд ва ё мувофиқи ҳукми суд дар ҷойҳои аз озодӣ маҳрумшудагон нигоҳ дошта мешаванд, ҳуқуқи дар интихобот ва раъйпурсӣ иштирок кардан надоранд.<br />

                Тартиби гузаронидани интихоботро қонунҳои конститутсионӣ ва қонунҳо танзим менамоянд. Баргузории раъйпурсӣ тибқи қонуни конститутсионӣ сурат мегирад.<br />

                <p>Моддаи 28 </p>

                Шаҳрвандон ҳуқуқи муттаҳид шудан доранд. Шаҳрванд ҳуқуқ дорад дар ташкили ҳизбҳои сиёсӣ, иттифоқҳои касаба ва дигар иттиҳодияҳои ҷамъиятӣ иштирок намояд, ихтиёран ба онҳо дохил ва аз онҳо хориҷ гардад.<br />

                Ҳизбҳои сиёсӣ дар асоси гуногунандешии сиёсӣ барои ташаккул ва ифодаи иродаи халқ мусоидат мекунанд ва дар ҳаёти сиёсӣ иштирок менамоянд. Сохтор ва фаъолияти онҳо бояд ба меъёрҳои демократӣ мувофиқ бошанд.<br />

                <p>Моддаи 29 </p>

                Шаҳрванд ҳуқуқ дорад дар маҷлис, гирдиҳамоӣ, намоиш, раҳпаймоии осоишта, ки қонун муқаррар кардааст, ширкат варзад.<br />

                Ҳеҷ касро ба ин тадбирҳо маҷбуран ҷалб кардан мумкин нест.<br />

                <p>Моддаи 30 </p>

                Ба ҳар кас озодии сухан, нашр, ҳуқуқи истифодаи воситаҳои ахбор кафолат дода мешавад.<br />

                Таблиғот ва ташвиқоте, ки бадбинӣ ва хусумати иҷтимоӣ, нажодӣ, миллӣ, динӣ ва забониро бармеангезанд, манъ аст.<br />

                Сензураи давлатӣ ва таъқиб барои танқид манъ аст.<br />

                Номгӯи маълумотҳоеро, ки сирри давлатӣ доранд, қонун муайян мекунад.<br />

                <p>Моддаи 31 </p>

                Шаҳрванд ҳуқуқ дорад шахсан ва ё якҷоя бо дигарон ба мақомоти давлатӣ муроҷиат намояд.<br />

                <p>Моддаи 32 </p>

                Ҳар кас ҳуқуқ дорад соҳиби моликият ва мерос бошад.<br />

                Ҳеҷ кас ҳуқуқ надорад ҳуқуқи шахсро ба моликият бекор ва маҳдуд кунад. Молу мулки шахсро барои эҳтиёҷоти ҷамъият фақат дар асоси қонун ва розигии соҳиби он бо пардохти арзиши пуррааш давлат гирифта метавонад.<br />

                Товони зарари моддӣ ва маънавие, ки шахс дар натиҷаи амали ғайриқонунии мақомоти давлатӣ, иттиҳодияҳои ҷамъиятӣ, ҳизбҳои сиёсӣ, дигар шахсони ҳуқуқӣ ва ё шахсони алоҳида мебинад, мувофиқи қонун аз ҳисоби онҳо рӯёнида мешавад.<br />

                <p>Моддаи 33 </p>

                Давлат оиларо ҳамчун асоси ҷамъият ҳимоя мекунад.<br />

                Ҳар кас ҳуқуқи ташкили оила дорад. Мардон ва занон, ки ба синни никоҳ расидаанд, ҳуқуқ доранд озодона ақди никоҳ банданд. Дар оиладорӣ ва бекор кардани ақди никоҳ зану шавҳар баробарҳуқуқанд.<br />

                Бисёрникоҳӣ манъ аст.<br />

                <p>Моддаи 34 </p>

                Модару кӯдак таҳти ҳимоя ва ғамхории махсуси давлатанд.<br />

                Падару модар барои таълиму тарбияи фарзандон ва фарзандони болиғу қобили меҳнат барои нигоҳубин ва таъминоти иҷтимоии падару модар масъул мебошанд.<br />

                Давлат барои ҳифзи кӯдакони ятим, маъюб ва таълиму тарбияи онҳо ғамхорӣ менамояд.<br />

                <p>Моддаи 35 </p>

                Ҳар кас ба меҳнат, интихоби касбу кор, ҳифзи меҳнат ва ҳимояи иҷтимоӣ ҳангоми бекорӣ ҳуқуқ дорад. Музди кор аз ҳадди ақали музди меҳнат набояд кам бошад.<br />

                Дар муносибатҳои меҳнатӣ ҳама гуна маҳдудият манъ аст. Барои иҷрои кори якхела музди баробар дода мешавад.<br />

                Ҳеҷ кас ба меҳнати маҷбурӣ ҷалб карда намешавад, ба истиснои мавридҳое, ки қонун муайян кардааст.<br />

                Дар корҳои вазнин, зеризаминӣ ва шароити меҳнаташон зарарнок истифодаи меҳнати занон ва ноболиғон манъ аст.<br />

                <p>Моддаи 36 </p>

                Ҳар кас ба манзил ҳуқуқ дорад. Ин ҳуқуқ бо роҳи сохтмони манзили давлатӣ, ҷамъиятӣ, кооперативӣ ва хусусӣ таъмин карда мешавад.<br />

                <p>Моддаи 37 </p>

                Шаҳрванд ҳуқуқи истироҳат дорад. Ин ҳуқуқ бо роҳи муқаррар кардани ҳафта ва рӯзи корӣ, рухсатии ҳарсолаи пардохтшаванда, рӯзҳои ҳарҳафтаинаи истироҳат ва шароитҳои дигаре таъмин карда мешавад, ки қонун муайян кардааст.<br />

                <p>Моддаи 38 </p>

                Ҳар шахс ҳуқуқи ҳифзи саломатӣ дорад. Шахс дар доираи муқаррарнамудаи қонун аз ёрии тиббии ройгон дар муассисаҳои нигаҳдории тандурустии давлатӣ истифода менамояд. Давлат барои солимгардонии муҳити зист, инкишофи оммавии варзиш, тарбияи ҷисмонӣ ва сайёҳӣ тадбирҳо меандешад.<br />

                Шаклҳои дигари ёрии тиббиро қонун муайян мекунад.<br />

                <p>Моддаи 39 </p>

                Ҳар шахс дар пиронсолӣ, ҳангоми беморӣ, маъюбӣ, гум кардани қобилияти кор, маҳрум шудан аз сарпараст ва мавридҳои дигаре, ки қонун муайян кардааст, кафолати таъмини иҷтимоӣ дорад.<br />

                <p>Моддаи 40 </p>

                Ҳар шахс ҳуқуқ дорад озодона дар ҳаёти фарҳангии ҷомеа, эҷоди бадеӣ, илмӣ ва техникӣ ширкат варзад, аз дастовардҳои онҳо истифода кунад.<br />

                Сарватҳои фарҳангӣ ва маънавиро давлат ҳимоя мекунад.<br />

                Моликияти зеҳнӣ таҳти ҳимояи қонун аст.<br />

                <p>Моддаи 41 </p>

                Ҳар шахс ҳуқуқи таҳсил дорад. Таълими умумии асосӣ ҳатмист. Давлат таълими умумии асосии ҳатмии ройгонро дар муассисаҳои таълимии давлатӣ кафолат медиҳад.<br />

                Шахс дар доираи муқаррарнамудаи қонун дар муассисаҳои таълимии давлатӣ метавонад ба таври ройгон таълими миёнаи умумӣ, ибтидоии касбӣ, миёнаи касбӣ ва олии касбӣ гирад.<br />

                Шаклҳои дигари таълимро қонун муайян мекунад.<br />

                <p>Моддаи 42 </p>

                Дар Тоҷикистон ҳар шахс вазифадор аст, ки Конститутсия ва қонунҳоро риоя кунад, ҳуқуқ, озодӣ, шаъну шарафи дигаронро эҳтиром намояд.<br />

                Надонистани қонун ҷавобгариро истисно намекунад.<br />

                <p>Моддаи 43 </p>

                Ҳифзи Ватан, ҳимояи манфиати давлат, таҳкими истиқлолият, амният ва иқтидори мудофиавии он вазифаи муқаддаси шаҳрванд аст.<br />

                Тартиби хизмати ҳарбиро қонун муайян мекунад.<br />

                <p>Моддаи 44 </p>

                Ҳифзи табиат, ёдгориҳои таърихиву фарҳангӣ вазифаи ҳар як шахс аст.<br />

                <p>Моддаи 45 </p>

                Супоридани андоз ва пардохтҳо, ки қонун муайян кардааст, ҳатмист.<br />

                Қонунҳое, ки андози навро муқаррар мекунанд ва ё шароити андозсупорандагонро вазнин менамоянд, қувваи бозгашт надоранд.<br />

                <p>Моддаи 46 </p>

                Ҳангоми таҳдиди бевосита ба ҳуқуқу озодиҳои шаҳрвандон, истиқлолияти давлат, тамомияти арзии он ва офатҳои табиӣ, ки дар натиҷаи он мақомоти конститутсионии ҷумҳурӣ наметавонад ба таври мӯътадил фаъолият намояд, ҳамчун тадбири муваққатӣ барои амнияти шаҳрвандон ва давлат вазъияти фавқулода эълон мегардад.<br />

                Муҳлати вазъияти фавқулода то се моҳ аст. Дар мавридҳои зарурӣ ин мӯҳлатро Президенти Ҷумҳурии Тоҷикистон метавонад дароз намояд.<br />

                <p>Моддаи 47 </p>

                Дар давраи вазъияти фавқулода ҳуқуқ ва озодиҳое, ки дар моддаҳои 16, 17, 18, 19, 20, 22, 25, 28-и Конститутсия пешбинӣ шудааст, маҳдуд карда намешавад.<br />

                Низоми ҳуқуқии вазъияти фавқулодаро қонуни конститутсионӣ муайян мекунад.
                <p className="text-center ">Боби сеюм</p>
                <p className="text-center">МАҶЛИСИ ОЛӢ</p>
                <p>Моддаи 48 </p>

                Маҷлиси Олӣ–парламенти Ҷумҳурии Тоҷикистон – мақоми олии намояндагӣ ва қонунгузори Ҷумҳурии Тоҷикистон мебошад.<br />

                Маҷлиси Олӣ аз ду Маҷлис – Маҷлиси миллӣ ва Маҷлиси намояндагон иборат аст.<br />

                Муҳлати ваколати Маҷлиси миллӣ ва Маҷлиси намояндагон 5 сол аст. Ваколати Маҷлиси миллӣ ва Маҷлиси намояндагон дар рӯзи оғози фаъолияти Маҷлиси миллӣ ва Маҷлиси намояндагони даъвати нав қатъ мегардад.<br />

                Ташкил ва фаъолияти Маҷлиси Олиро қонуни конститутсионӣ танзим мекунад.<br />

                <p>Моддаи 49 </p>

                Интихоботи Маҷлиси намояндагон ба таври умумӣ, баробар, мустақим ва бо овоздиҳии пинҳонӣ сурат мегирад. Маҷлиси намояндагон доимоамалкунанда ва касбӣ мебошад. Вакили Маҷлиси намояндагон шахсе интихоб шуда метавонад, ки танҳо шаҳрвандии Ҷумҳурии Тоҷикистонро дошта бошад ва синни ӯ аз 30 кам набуда, дорои таҳсилоти олӣ бошад.<br />

                Аз чор се ҳиссаи аъзои Маҷлиси миллӣ ба таври ғайримустақим дар маҷлисҳои якҷояи вакилони халқи Вилояти Мухтори Кӯҳистони Бадахшон ва шаҳру ноҳияҳои он, вилоятҳо ва шаҳру ноҳияҳои онҳо, шаҳри Душанбе ва ноҳияҳои он, шаҳру ноҳияҳои тобеи ҷумҳурӣ (якҷоя) бо овоздиҳии пинҳонӣ интихоб мегардад. Дар Маҷлиси миллӣ Вилояти Мухтори Кӯҳистони Бадахшон, вилоятҳо, шаҳри Душанбе, шаҳрҳо ва ноҳияҳои тобеи ҷумҳурӣ намояндагони баробар доранд.<br />

                Аз чор як ҳиссаи аъзои Маҷлиси миллиро Президенти Ҷумҳурии Тоҷикистон таъин мекунад.<br />

                Фаъолияти Маҷлиси миллӣ даъватӣ мебошад.<br />

                Узви Маҷлиси миллӣ шахсе интихоб ё таъин шуда метавонад, ки танҳо шаҳрвандии Ҷумҳурии Тоҷикистонро дошта бошад ва синни ӯ аз 30 кам набуда, дорои таҳсилоти олӣ бошад.<br />

                Ҳар Президенти собиқи Ҷумҳурии Тоҷикистон узви якумраи Маҷлиси миллӣ мебошад, агар ӯ аз истифодаи ин ҳуқуқ даст накашад.<br />

                Узви Маҷлиси миллӣ ва вакили Маҷлиси намояндагон баъди интихоб ё таъин шудан дар иҷлосияи Маҷлиси миллӣ ва Маҷлиси намояндагон ба халқи Тоҷикистон савганд ёд мекунанд.<br />

                Шумораи аъзои Маҷлиси миллӣ ва вакилони Маҷлиси намояндагон, тартиби интихоб ё таъин гардидани онҳоро қонуни конститутсионӣ муайян менамояд.<br />

                <p>Моддаи 50 </p>

                Аъзои Ҳукумат, судяҳо, кормандони мақомоти ҳифзи ҳуқуқ, хизматчиёни ҳарбӣ ва шахсони дигаре, ки қонуни конститутсионӣ муайян кардааст, наметавонанд узви Маҷлиси миллӣ бошанд.<br />

                Шаҳрванд наметавонад дар як вақт узви Маҷлиси миллӣ ва вакили Маҷлиси намояндагон бошад. Узви Маҷлиси миллӣ наметавонад вакили зиёда аз ду мақоми намояндагӣ бошад.<br />

                Вакили Маҷлиси намояндагон наметавонад вакили дигар мақомоти намояндагӣ бошад, вазифаи дигареро иҷро кунад, фаъолияти соҳибкорӣ намояд, ба истиснои фаъолияти илмиву эҷодӣ ва омӯзгорӣ.<br />

                <p>Моддаи 51 </p>

                Узви Маҷлиси миллӣ ва вакили Маҷлиси намояндагон ба амри интихобкунандагон тобеъ набуда, ҳуқуқ дорад фикри худро озодона изҳор намояд, мувофиқи ақидаҳои худ овоз диҳад.<br />

                Узви Маҷлиси миллӣ ва вакили Маҷлиси намояндагон ҳуқуқи дахлнопазирӣ дорад, ӯро ҳабс кардан, дастгир кардан, маҷбуран овардан, кофтуков кардан мумкин нест, ба истиснои дастгир шуданаш дар ҷойи содири ҷиноят. Узви Маҷлиси миллӣ ва вакили Маҷлиси намояндагон ҳамчунон мавриди кофтукови шахсӣ қарор дода намешавад, ба истиснои ҳолатҳое, ки қонун барои таъмини амнияти дигарон муқаррар намудааст. Масъалаи маҳрум намудани дахлнопазирии узви Маҷлиси миллӣ ва вакили Маҷлиси намояндагон бо пешниҳоди Прокурори генералӣ аз ҷониби маҷлиси дахлдор ҳал карда мешавад.<br />

                Ваколати узви Маҷлиси миллӣ ва вакили Маҷлиси намояндагон ҳангоми вафот, истеъфо, ғайри қобили амал эътироф шудани онҳо аз ҷониби суд, эътибори қонунӣ пайдо кардани ҳукми айбдоркунандаи суд, қатъи шаҳрвандӣ, соҳиб шудан ба шаҳрвандии давлати дигар, тарки доимии ҷумҳурӣ, ишғоли вазифае, ки ба ваколати узви Маҷлиси миллӣ мувофиқ нест, парокандашавии Маҷлиси миллӣ ва Маҷлиси намояндагон қатъ мегардад.<br />

                Вазъи ҳуқуқии узви Маҷлиси миллӣ ва вакили Маҷлиси намояндагонро қонуни конститутсионӣ танзим менамояд.<br />

                <p>Моддаи 52 </p>

                Иҷлосияи якуми Маҷлиси миллӣ ва Маҷлиси намояндагонро дар давоми як моҳи баъди интихоби онҳо Президенти Ҷумҳурии Тоҷикистон даъват мекунад.<br />

                Иҷлосияи якуми Маҷлиси миллӣ ва Маҷлиси намояндагонро узв ва вакили синну солаш калонтарин мекушояд ва то интихоб шудани раисони ин Маҷлисҳо онро мебарад.<br />

                Фаъолияти Маҷлиси миллӣ дар шакли иҷлосия сурат мегирад. Иҷлосияи Маҷлиси миллӣ соле на камтар аз чор бор аз тарафи Раиси Маҷлиси миллӣ даъват карда мешавад.<br />

                Фаъолияти Маҷлиси намояндагон дар шакли иҷлосия сурат мегирад. Иҷлосияи навбатии Маҷлиси намояндагон дар як сол як маротиба аз рӯзи аввали кории моҳи октябр то рӯзи охирини кории моҳи июн гузаронида мешавад.<br />

                Дар давраи байни иҷлосияҳои Маҷлиси миллӣ ва Маҷлиси намояндагон ҳангоми зарурат Президенти Ҷумҳурии Тоҷикистон иҷлосияҳои ғайринавбатии онҳоро даъват менамояд. Дар ин иҷлосияҳо танҳо он масъалаҳое баррасӣ мешаванд, ки боиси даъвати ин иҷлосияҳо гаштаанд.<br />

                <p>Моддаи 53 </p>

                Маҷлиси миллӣ ва Маҷлиси намояндагон аз байни аъзо ва вакилон раисони Маҷлисҳо, муовинони якум ва муовинони онҳоро интихоб менамоянд. Яке аз муовинони Раиси Маҷлиси миллӣ аз ҳисоби намояндагони Вилояти Мухтори Кӯҳистони Бадахшон мебошад.<br />

                Раиси Маҷлиси миллӣ ва Раиси Маҷлиси намояндагон бо овоздиҳии пинҳонӣ бо тарафдории аксарияти шумораи умумии аъзо ва вакилони онҳо интихоб мешаванд. Тартиби интихоби муовинони Раиси Маҷлиси миллӣ ва Раиси Маҷлиси намояндагонро Дастури Маҷлисҳо танзим мекунад.<br />

                Раисони Маҷлиси миллӣ ва Маҷлиси намояндагон дар назди Маҷлиси дахлдор ҳисоботдиҳанда мебошанд ва онҳо метавонанд бо тарафдории на камтар аз се ду ҳиссаи шумораи умумии аъзо ва вакилон бозхонда шаванд.<br />

                Раисони Маҷлиси миллӣ ва Маҷлиси намояндагон, муовинони якум ва муовинони онҳо ба иҷлосия роҳбарӣ мекунанд ва дигар масъалаҳои дахлдорро ҳал менамоянд.<br />

                Маҷлиси миллӣ ва Маҷлиси намояндагон мақомоти ҳамоҳангсозанда ва кории худро мустақилона ташкил медиҳанд, инчунин кумита ва комиссияҳои дахлдорро таъсис менамоянд ва аз рӯи масъалаҳои ба Маҷлисҳо тааллуқдошта муҳокимаҳои парламентӣ доир мекунанд.<br />

                Мақомоти ҳамоҳангсозандаи Маҷлиси миллӣ ва Маҷлиси намояндагон дар алоҳидагӣ ҷаласа мегузаронанд.<br />

                Маҷлиси миллӣ ва Маҷлиси намояндагон Дастури фаъолияти худро қабул мекунанд.<br />

                <p>Моддаи 54 </p>

                Маҷлиси миллӣ ва Маҷлиси намояндагон алоҳида ҷаласа мегузаронанд.<br />

                Ҷаласаҳои Маҷлиси миллӣ ва Маҷлиси намояндагон ҳамон вақт гузаронида мешавад, ки агар аз се ду ҳиссаи шумораи умумии аъзо ва вакилони онҳо ҳузур дошта бошанд. Ҷаласаҳои Маҷлиси миллӣ ва Маҷлиси намояндагон ошкоро гузаронида мешаванд. Дар ҳолатҳои пешбиникардаи қонун ва Дастури Маҷлиси миллӣ ва Маҷлиси намояндагон мумкин аст ҷаласаи пӯшида гузаронида шавад.<br />

                Маҷлиси миллӣ ва Маҷлиси намояндагон дар ҳолатҳои пешбининамудаи Конститутсия ҷаласаҳои якҷоя мегузаронанд.<br />

                <p>Моддаи 55 </p>
                Салоҳияти Маҷлиси миллӣ ва Маҷлиси намояндагон ҳангоми гузаронидани ҷаласаҳои якҷоя:<br />
                <ol>
                    <li>Тасдиқи фармони Президент дар бораи таъин намудан ва озод кардани Сарвазир ва дигар аъзои Ҳукумат;</li>
                    <li>Тасдиқи фармони Президент дар бораи ҷорӣ намудани ҳолати ҷангӣ ва вазъияти фавқулода;</li>
                    <li> Ризоият ба истифодаи Қувваҳои Мусаллаҳи Ҷумҳурии Тоҷикистон берун аз ҳудуди он барои иҷрои уҳдадориҳои байналмилалии Тоҷикистон;</li>
                    <li> Таъини интихоботи Президент;</li>
                    <li> Қабули истеъфои Президент;</li>
                    <li> Сарфароз гардонидани Президент бо мукофотҳои давлатӣ ва рутбаи олии ҳарбӣ;</li>
                    <li> Баррасии масъалаи дахлнопазирии Президент.</li>
                </ol>
                Маҷлиси миллӣ ва Маҷлиси намояндагон дар ҷаласаҳои якҷояи худ аз рӯйи масъалаҳои зикршудаи салоҳияташон қарор қабул мекунанд. Қарори якҷояи Маҷлиси миллӣ ва Маҷлиси намояндагон бо тарафдории аксарияти шумораи умумии аъзои Маҷлиси миллӣ ва вакилони Маҷлиси намояндагон, ки ҳар яке аз маҷлисҳо дар алоҳидагӣ овоз медиҳанд, қабул мегардад, агар тартиби дигари қабули қарорро Конститутсия муқаррар накарда бошад.
                Дар ҷаласаи якҷояи Маҷлиси миллӣ ва Маҷлиси намояндагон Президент савганд ёд мекунад ва бо паёми худ дар бораи самтҳои асосии сиёсати дохилӣ ва хориҷии ҷумҳурӣ баромад менамояд.

                <p>Моддаи 56 </p>
                Салоҳияти Маҷлиси миллӣ:
                <ol>
                    <li>Таъсис ва барҳам додани воҳидҳои маъмурию ҳудудӣ ва тағйири онҳо;</li>
                    <li>Интихоб ва бозхонди раис, муовинон ва судяҳои Суди конститутсионӣ, Суди Олӣ ва Суди Олии иқтисодӣ бо пешниҳоди Президент;</li>
                    <li>Ҳалли масъалаи бекор кардани дахлнопазирии раис, муовинон ва судяҳои Суди конститутсионӣ, Суди Олӣ ва Суди Олии иқтисодӣ;</li>
                    <li>Ризоият барои таъин ва озод намудани Прокурори генералӣ ва муовинони ӯ;</li>
                    <li> Амалӣ намудани ваколатҳои дигаре, ки Конститутсия ва қонунҳо муайян кардаанд.</li>

                </ol>
                Маҷлиси миллӣ аз рӯйи масъалаҳои дар салоҳияташ буда қарор қабул мекунад. Қарори Маҷлиси миллӣ бо тарафдории аксарияти шумораи умумии аъзои он қабул мегардад, агар тартиби дигари қабули қарорро Конститутсия муқаррар накарда бошад.
                <p>Моддаи 57 </p>
                Салоҳияти Маҷлиси намояндагон:
                <ol>
                    <li>Таъсиси Комиссияи марказии интихобот ва раъйпурсии Ҷумҳурии Тоҷикистон, интихоб ва бозхонди раис, муовин ва аъзои он бо пешниҳоди Президент;</li>
                    <li> Ба муҳокимаи халқ пешниҳод намудани лоиҳаи қонунҳо ва дигар масъалаҳои муҳими давлатию ҷамъиятӣ;</li>
                    <li>Тасдиқи барномаҳои иқтисодӣ ва иҷтимоӣ;</li>
                    <li> Ризоият ба додугирифти қарзи давлатӣ;</li>
                    <li> Тасдиқ ва бекор кардани шартномаҳои байналмилалӣ;</li>
                    <li>Таъини раъйпурсӣ;</li>
                    <li> Таъсиси судҳо;</li>
                    <li> Тасдиқи рамзҳои давлатӣ;</li>
                    <li>Тасдиқи мукофотҳои давлатӣ;</li>
                    <li>Тасдиқи фармонҳои Президент дар бораи таъин ва озод намудани раиси Бонки миллӣ ва муовинони ӯ;</li>
                    <li>  Муқаррар намудани рутбаҳои ҳарбӣ, дипломатӣ, рутбаҳо ва унвонҳои махсус;</li>
                    <li>  Муайян намудани маоши Президент;</li>
                    <li>   Амалӣ намудани ваколатҳои дигаре, ки Конститутсия ва қонунҳо муайян кардаанд.</li>

                </ol>
                Маҷлиси намояндагон аз рӯйи масъалаҳои дар салоҳияташ буда қарор қабул мекунад. Қарори Маҷлиси намояндагон бо тарафдории аксарияти шумораи умумии вакилон қабул мегардад, агар тартиби дигари қабули қарорро Конститутсия муайян накарда бошад.

                Дар ҷаласаи Маҷлиси намояндагон роҳбарони давлатҳои хориҷӣ метавонанд суханронӣ кунанд.

                <p>Моддаи 58 </p>

                Аъзои Маҷлиси миллӣ, вакили Маҷлиси намояндагон, Президенти Ҷумҳурии Тоҷикистон, Ҳукумати Тоҷикистон, Маҷлиси вакилони халқи Вилояти Мухтори Кӯҳистони Бадахшон ҳуқуқи ташаббуси қонунгузорӣ доранд.

                <p>Моддаи 59 </p>

                Лоиҳаи қонунҳо ба Маҷлиси намояндагон пешниҳод мешаванд.

                Лоиҳаи қонун дар бораи авф аз тарафи Президенти Ҷумҳурии Тоҷикистон ба Маҷлиси намояндагон пешниҳод мешавад.

                Лоиҳаи Қонун дар бораи буҷет, оид ба муқаррар кардан ва бекор кардани андозҳо аз ҷониби Ҳукумати Ҷумҳурии Тоҷикистон ба Маҷлиси намояндагон пешниҳод мешавад.

                <p>Моддаи 60 </p>

                Қонунҳоро Маҷлиси намояндагон қабул менамояд. Қонун бо тарафдории аксарияти шумораи умумии вакилон қабул мегардад, агар тартиби дигарро Конститутсия муқаррар накарда бошад.

                Қонунҳое, ки Маҷлиси намояндагон қабул намудааст ба Маҷлиси миллӣ пешниҳод мешаванд, ба истиснои қонунҳо дар бораи буҷети давлатӣ ва авф.

                Маҷлиси миллӣ қонунро бо тарафдории аксарияти шумораи умумии аъзои худ ҷонибдорӣ мекунад. Дар мавриди дастгирӣ наёфтани қонун аз ҷониби Маҷлиси миллӣ қонун такроран дар Маҷлиси намояндагон баррасӣ мешавад.

                Дар сурати бо қарори Маҷлиси миллӣ норозӣ будани Маҷлиси намояндагон, қонун ҳамон вақт қабулшуда ҳисоб мешавад, ки агар Маҷлиси намояндагон онро такроран бо тарафдории на камтар аз се ду ҳиссаи шумораи умумии вакилон тасдиқ намояд.

                Қонунҳо дар бораи буҷети давлатӣ ва авф танҳо аз ҷониби Маҷлиси намояндагон қабул карда мешаванд. Маҷлиси намояндагон иҷрои буҷети давлатиро назорат мекунад.

                <p>Моддаи 61 </p>

                Қонунҳои конститутсионӣ оид ба масъалаҳое қабул мешаванд, ки Конститутсия муайян намудааст. Қонунҳои конститутсионӣ бо тарафдории на камтар аз се ду ҳиссаи шумораи умумии вакилони Маҷлиси намояндагон қабул мегарданд ва Маҷлиси миллӣ бо тарафдории на камтар аз се ду ҳиссаи аъзои худ ҷонибдорӣ мекунад.

                Дар сурати бо Қарори Маҷлиси миллӣ норозӣ будани Маҷлиси намояндагон, қонуни конститутсионӣ ҳамон вақт қабулшуда ҳисоб мешавад, ки агар Маҷлиси намояндагон онро такроран бо тарафдории на камтар аз чор се ҳиссаи шумораи умумии вакилон тасдиқ намояд.

                Тафсири Конститутсияро тибқи тартиби мазкур Маҷлиси намояндагон дар шакли қонуни конститутсионӣ қабул намуда, Маҷлиси миллӣ онро ҷонибдорӣ менамояд.

                <p>Моддаи 62 </p>

                Қонунҳо барои имзо ва интишор ба Президенти Ҷумҳурии Тоҷикистон пешниҳод мешаванд. Агар Президент ба қонун ё қисми он розӣ набошад, қонунро дар муддати понздаҳ рӯз бо далелу эродҳо ба Маҷлиси намояндагон бармегардонад. Маҷлиси миллӣ ва Маҷлиси намояндагон бо тартиби муқарраркардаи Конститутсия қонуни мазкурро такроран баррасӣ менамоянд. Дар сурати баррасии такрорӣ қонун дар матни пештар қабулшудааш бо аксарияти аз се ду ҳиссаи шумораи умумии аъзои Маҷлиси миллӣ ва вакилони Маҷлиси намояндагон дастгирӣ ёбад, Президент дар муддати даҳ рӯз ба қонун имзо мегузорад ва онро интишор менамояд.

                Ҳангоми баррасии қонуни аз тарафи Президенти Ҷумҳурии Тоҷикистон баргардонидашуда, ки онро пештар Маҷлиси намояндагон бо аз се ду ҳиссаи овозҳо қабул намуда буд, Маҷлиси миллӣ ва Маҷлиси намояндагон онро такроран бо аксарияти на камтар аз се ду ҳиссаи овозҳо тарафдорӣ мекунанд.

                Агар Президент қонуни конститутсиониро баргардонад, Маҷлиси намояндагон ва Маҷлиси миллӣ бо тартиби муқарраркардаи Конститутсия қонуни мазкурро такроран баррасӣ менамоянд. Дар сурати баррасии такрорӣ қонуни конститутсионӣ дар матни пештар қабулшудааш бо аксарияти аз чор се ҳиссаи шумораи умумии аъзои Маҷлиси миллӣ ва вакилони Маҷлиси намояндагон тасдиқ шавад, Президент дар муддати даҳ рӯз ба қонуни конститутсионӣ имзо мегузорад ва онро интишор менамояд.

                <p>Моддаи 63 </p>

                Маҷлиси миллӣ ва Маҷлиси намояндагон метавонанд пеш аз муҳлат дар ҷаласаи якҷояи худ бо тарафдории на камтар аз се ду ҳиссаи аъзои Маҷлиси миллӣ ва вакилони Маҷлиси намояндагон ихтиёран пароканда шаванд.

                Маҷлиси миллӣ ва Маҷлиси намояндагон дар давраи вазъияти фавқулода ва ҳолати ҷангӣ пароканда намешаванд.
                <p className="text-center ">Боби чаҳорум</p>
                <p className="text-center">ПРЕЗИДЕНТ</p>
                <p>Моддаи 64 </p>

                Президенти Ҷумҳурии Тоҷикистон сарвари давлат ва ҳокимияти иҷроия (Ҳукумат) аст.

                Президент ҳомии Конститутсия ва қонунҳо, ҳуқуқу озодиҳои инсон ва шаҳрванд, кафили истиқлолияти миллӣ, ягонагӣ ва тамомияти арзӣ, пойдориву бардавомии давлат, мураттабии фаъолияти мақомоти давлатӣ ва ҳамкории онҳо, риояи шартномаҳои байналмилалии Тоҷикистон мебошад.

                <p>Моддаи 65 </p>

                Президентро шаҳрвандони Тоҷикистон ба тарзи умумӣ, мустақим, баробар ва овоздиҳии пинҳонӣ ба муҳлати 7 сол интихоб менамоянд.

                Шахсе ба номзадии Президенти Ҷумҳурии Тоҷикистон пешниҳод шуда метавонад, ки танҳо шаҳрвандии Ҷумҳурии Тоҷикистонро дошта бошад, синни ӯ аз 30 кам набуда, дорои таҳсилоти олӣ бошад, забони давлатиро донад ва дар ҳудуди ҷумҳурӣ на камтар аз 10 соли охир истиқомат дошта бошад.

                Шахсе ба номзадии Президент ба қайд гирифта мешавад, ки ҳадди ақал 5 фоизи интихобкунандагон ба пешниҳоди номзадии ӯ имзо гузошта бошанд.

                Як шахс ба вазифаи Президент бештар аз ду муҳлат пай дар пай интихоб шуда наметавонад.<br />

                Маҳдудияти дар қисми чоруми ҳамин модда пешбинигардида нисбат ба Асосгузори сулҳу ваҳдати миллӣ – Пешвои миллат татбиқ намегардад. Вазъи ҳуқуқӣ ва ваколатҳои Асосгузори сулҳу ваҳдати миллӣ – Пешвои миллатро қонуни конститутсионӣ муайян мекунад.

                <p>Моддаи 66 </p>

                Интихоботи Президент вақте боэътимод шумурда мешавад, ки дар он аз нисф зиёди интихобкунандагон ширкат варзида бошанд.

                Номзаде Президент интихобшуда ҳисоб меёбад, ки ба тарафдории ӯ бештар аз нисфи интихобкунандагони ширкатварзида овоз дода бошанд.

                Тартиби интихоби Президентро қонуни конститутсионӣ муайян мекунад.

                <p>Моддаи 67 </p>

                Президент пеш аз шурӯъи вазифа дар ҷаласаи якҷояи Маҷлиси миллӣ ва Маҷлиси намояндагон савганд ёд мекунад:

                «Ман, ҳамчун Президент савганд ёд мекунам, ки Конститутсия ва қонунҳои ҷумҳуриро ҳимоя менамоям, таъмини ҳуқуқ, озодиҳо ва шарафи шаҳрвандонро кафолат медиҳам, сарзамин, истиқлолияти сиёсиву иқтисодӣ ва фарҳангии Тоҷикистонро ҳифз мекунам, ба халқ содиқона хидмат менамоям».

                Ваколати Президент баъд аз савганд ёд кардани Президенти нав қатъ мегардад.

                <p>Моддаи 68 </p>

                Президент наметавонад вазифаи дигарро иҷро намояд, вакили мақомоти намояндагӣ бошад, ба соҳибкорӣ машғул шавад.

                <p>Моддаи 69 </p>
                Салоҳияти Президент:
                <ol>
                    <li>Самтҳои асосии сиёсати дохилӣ ва хориҷии ҷумҳуриро муайян мекунад;</li>
                    <li> Тоҷикистонро дар дохили кишвар ва дар муносибатҳои байналмилалӣ намояндагӣ мекунад;</li>
                    <li>Вазоратҳо ва кумитаҳои давлатиро таъсис ва барҳам медиҳад;</li>
                    <li>Сарвазир ва дигар аъзои ҳукуматро таъин ва озод мекунад; фармон дар бораи таъин ва озод кардани Сарвазир ва дигар аъзои Ҳукуматро ба тасдиқи ҷаласаи якҷояи Маҷлиси миллӣ ва Маҷлиси намояндагон пешниҳод менамояд;</li>
                    <li>Раисони Вилояти Мухтори Кӯҳистони Бадахшон, вилоят, шаҳри Душанбе, шаҳр ва ноҳияро таъин ва озод мекунад ва ба тасдиқи Маҷлиси дахлдори вакилони халқ пешниҳод менамояд;</li>
                    <li> Санадҳои мақомоти ҳокимияти иҷроияро ҳангоми мухолифати онҳо ба Конститутсия ва қонунҳо бекор мекунад ва ё бозмедорад;</li>
                    <li>  Раиси Бонки миллӣ ва муовинони ӯро таъин ва озод мекунад ва фармонро барои тасдиқ ба Маҷлиси намояндагон пешниҳод менамояд;</li>
                    <li> Номзадии раис, муовинон ва судяҳои Суди конститутсионӣ, Суди Олӣ, Суди Олии иқтисодиро барои интихоб ва бозхонд ба Маҷлиси миллӣ пешниҳод менамояд;</li>
                    <li>Бо ризоияти Маҷлиси миллӣ Прокурори генералӣ ва муовинони ӯро таъин ва озод мекунад;</li>
                    <li>Дастгоҳи иҷроияи Президентро таъсис медиҳад;</li>
                    <li>  Шӯрои амниятро таъсис ва роҳбарӣ мекунад;</li>
                    <li> Судяҳои суди ҳарбӣ, судҳои Вилояти Мухтори Кӯҳистони Бадахшон, вилоят, шаҳри Душанбе, шаҳр ва ноҳия ва судҳои иқтисодии Вилояти Мухтори Кӯҳистони Бадахшон, вилоят, шаҳри Душанберо таъин ва озод мекунад;</li>
                    <li>  Раъйпурсӣ, интихоботи Маҷлиси миллӣ ва Маҷлиси намояндагон ва мақомоти намояндагии маҳаллиро таъин мекунад;</li>
                    <li>  Ба қонунҳо имзо мегузорад;</li>
                    <li>  Низоми пулиро муайян менамояд ва маълумотро ба Маҷлиси миллӣ ва Маҷлиси намояндагон пешниҳод менамояд;</li>
                    <li>  Ихтиёрдор ва масъули сармояи захиравӣ мебошад;</li>
                    <li>  Ба татбиқи сиёсати хориҷӣ роҳбарӣ мекунад, шартномаҳои байналмилалиро имзо ва ба тасдиқи Маҷлиси намояндагон пешниҳод менамояд;</li>
                    <li>   Сарони намояндагиҳои дипломатиро дар давлатҳои хориҷӣ, намояндаҳои ҷумҳуриро дар ташкилотҳои байналмилалӣ таъин ва озод мекунад;</li>
                    <li>   Эътимодномаҳои сарони намояндагиҳои дипломатии давлатҳои хориҷиро қабул менамояд;</li>
                    <li>   Сарфармондеҳи Олии Қувваҳои Мусаллаҳи Тоҷикистон мебошад; фармондеҳони қӯшунҳои Қувваҳои Мусаллаҳи Тоҷикистонро таъин ва озод мекунад;</li>
                    <li>    Ҳангоми таҳдиди хатари воқеӣ ба амнияти давлат ҳолати ҷангро эълон менамояд ва фармонро ба тасдиқи ҷаласаи якҷояи Маҷлиси миллӣ ва Маҷлиси намояндагон пешниҳод мекунад;</li>
                    <li>  Барои иҷрои уҳдадориҳои байналмилалии Тоҷикистон Қувваҳои Мусаллаҳи Ҷумҳурии Тоҷикистонро берун аз ҳудуди он бо ризоияти Маҷлиси миллӣ ва Маҷлиси намояндагон истифода мебарад;</li>
                    <li>  Дар саросари ҷумҳурӣ ва ё дар маҳалҳои алоҳидаи он вазъияти фавқулода эълон намуда, фармонро фавран ба тасдиқи ҷаласаи якҷояи Маҷлиси миллӣ ва Маҷлиси намояндагон пешниҳод менамояд ва ба Созмони Милали Муттаҳид хабар медиҳад;</li>
                    <li>  БМасъалаҳои шаҳрвандиро ҳал мекунад;</li>
                    <li>   Паноҳгоҳи сиёсӣ медиҳад;</li>
                    <li>   Масаълаҳои бахшиши ҷазоро ҳал мекунад;</li>
                    <li>   Бо рутбаҳои олии ҳарбӣ, дипломатӣ, рутбаҳо ва унвонҳои махсус сарфароз мегардонад;</li>
                    <li>   Шаҳрвандонро бо мукофотҳои давлатӣ, ҷоизаҳои давлатӣ, нишонҳо ва унвонҳои ифтихории Тоҷикистон сарфароз мегардонад;</li>
                    <li>   Ваколатҳои дигареро, ки Конститутсия ва қонунҳо муайян кардаанд, амалӣ менамояд.</li>
                </ol>
                <p>Моддаи 70 </p>

                Президент дар доираи салоҳияти худ фармон мебарорад ва амр медиҳад, дар бораи вазъи кишвар ба ҷаласаи якҷояи Маҷлиси миллӣ ва Маҷлиси намояндагон маълумот медиҳад, масъалаҳоеро, ки заруру муҳим мешуморад, ба муҳокимаи ҷаласаи якҷояи Маҷлиси миллӣ ва Маҷлиси намояндагон пешниҳод менамояд.<br />

                <p>Моддаи 71 </p>

                Ҳангоми вафот, истеъфо ва ғайри қобили амал донистани Президент вазифаи ӯ то ба вазифааш шурӯъ намудани Президенти нав ба зиммаи Раиси Маҷлиси миллӣ мегузарад. Дар ин маврид ваколати Раиси Маҷлиси миллӣ ба зиммаи муовини якуми ӯ мегузарад.

                Дар ҳолатҳои зикршуда дар муҳлати се моҳ интихоботи Президент гузаронида мешавад.<br />

                Ваколатҳои Президент дар ҳолате, ки ӯ дар ҷаласаи якҷояи Маҷлиси миллӣ ва Маҷлиси намояндагон дар бораи ба истеъфо баромаданаш хабар медиҳад, бо тарафдории аксарияти аъзои Маҷлиси миллӣ ва вакилони Маҷлиси намояндагон, ки ҳар яке аз онҳо дар алоҳидагӣ овоз медиҳанд, қатъ карда мешавад.<br />

                Дар сурате, ки Президент бинобар беморӣ вазифаҳои худро иҷро карда натавонад, ҳар ду Маҷлис дар ҷаласаи якҷояи худ дар асоси хулосаи комиссияи тиббии давлатии ташкил кардаашон, дар бораи пеш аз муҳлат аз мансаб озод намудани Президент бо тарафдории на камтар аз се ду ҳиссаи овозҳои шумораи умумии аъзо ва вакилони ҳар яке аз Маҷлисҳо қарор қабул мекунанд.<br />

                Таъминоти иҷтимоӣ, хизматрасонӣ ва муҳофизати Президенти Ҷумҳурии Тоҷикистонро қонуни конститутсионӣ танзим менамояд.<br />

                <p>Моддаи 72 </p>

                Президент ҳуқуқи дахлнопазирӣ дорад.

                Дахлнопазирии Президент дар сурати аз тарафи ӯ содир шудани хиёнат ба давлат дар асоси хулосаи Суди конститутсионӣ ва бо тарафдории аз се ду ҳиссаи шумораи умумии аъзои Маҷлиси миллӣ ва вакилони Маҷлиси намояндагон, ки ҳар яке аз онҳо дар алоҳидагӣ овоз медиҳанд, бекор карда мешавад.
                <p className="text-center ">Боби панҷум</p>
                <p className="text-center">ҲУКУМАТ</p>
                <p>Моддаи 73 </p>

                Ҳукумати ҷумҳурӣ аз Сарвазир, муовини якум ва муовинони ӯ, вазирон, раисони кумитаҳои давлатӣ иборат аст.<br />

                Ҳукумат роҳбарии самараноки соҳаҳои иқтисодӣ, иҷтимоӣ, фарҳангӣ ва иҷрои қонунҳо, қарорҳои якҷояи Маҷлиси миллӣ ва Маҷлиси намояндагон, қарорҳои Маҷлиси миллӣ, қарорҳои Маҷлиси намояндагон, фармону амрҳои Президенти Тоҷикистонро таъмин мекунад.<br />

                Аъзои Ҳукумат баъди аз ҷониби Президенти Ҷумҳурии Тоҷикистон таъин шудан ва тасдиқ гардидани фармон дар ҷаласаи якҷояи Маҷлиси миллӣ ва Маҷлиси намояндагон ба Президенти Ҷумҳурии Тоҷикистон савганд ёд мекунанд.<br />

                Аъзои Ҳукумат бояд танҳо шаҳрвандии Ҷумҳурии Тоҷикистонро дошта бошанд ва онҳо наметавонанд вазифаи дигареро иҷро намоянд, вакили мақомоти намояндагӣ бошанд, ба соҳибкорӣ машғул шаванд, ба истиснои фаъолияти илмиву эҷодӣ ва омӯзгорӣ.<br />

                <p>Моддаи 74 </p>

                Ҳукумат мувофиқи Конститутсия ва қонунҳои ҷумҳурӣ қарор мебарорад ва фармоиш медиҳад, ки иҷрои онҳо дар ҳудуди Тоҷикистон ҳатмист.

                Ҳукумат ваколаташро дар назди Президенти навинтихобшуда вомегузорад.

                Ҳукумат дар мавриди ғайриимкон донистани иҷрои фаъолияти муътадили худ метавонад ба Президент аз хусуси истеъфо арз намояд. Ҳар як узви Ҳукумат ҳуқуқи истеъфо дорад.

                Тартиби ташкил, фаъолият ва салоҳияти Ҳукуматро қонуни конститутсионӣ муайян мекунад.

                <p>Моддаи 75 </p>

                Ҳукумат барномаҳои иқтисодиву иҷтимоӣ, сиёсати додугирифти қарзи давлатӣ ва ёрии иқтисодӣ ба дигар давлатҳо, лоиҳаи буҷети давлатӣ, масъалаи андозаи имконпазири касри буҷети давлатӣ ва манбаи ҷуброни онро ба Маҷлиси намояндагон пешниҳод менамояд.
                <p className="text-center ">Боби шашум</p>
                <p className="text-center">МАҚОМОТИ МАҲАЛЛИИ ҲОКИМИЯТИ ДАВЛАТӢ ВА ХУДИДОРАКУНӢ</p>
                <p>Моддаи 76 </p>

                Мақомоти маҳаллии ҳокимияти давлатӣ аз мақомоти намояндагӣ ва иҷроия иборат буда, дар доираи салоҳияти худ амал мекунад. Онҳо иҷрои Конститутсия, қонунҳо, қарорҳои якҷояи Маҷлиси миллӣ ва Маҷлиси намояндагон, қарорҳои Маҷлиси миллӣ, қарорҳои Маҷлиси намояндагон, санадҳои Президент ва Ҳукумати Ҷумҳурии Тоҷикистонро таъмин менамоянд.<br />

                <p>Моддаи 77 </p>

                Мақомоти намояндагии маҳаллӣ дар вилоят, шаҳр ва ноҳия Маҷлиси вакилони халқ аст, ки онро раис роҳбарӣ мекунад. Муҳлати ваколати Маҷлиси вакилони халқ 5 сол аст.<br />

                Маҷлиси вакилони халқ буҷети маҳаллӣ ва ҳисоботи иҷрои онро тасдиқ мекунад, роҳҳои инкишофи иқтисодиву иҷтимоии маҳалро муайян менамояд, андоз ва пардохти маҳаллиро мувофиқи қонун муқаррар мекунад, дар доираи қонун тарзи идора ва ихтиёрдории моликияти коммуналиро муайян менамояд ва ваколатҳои дигареро амалӣ месозад, ки Конститутсия ва қонунҳо муайян кардаанд.

                <p>Моддаи 78 </p>

                Мақомоти иҷроияи маҳаллии ҳокимияти давлатиро раиси вилоят, шаҳр ва ноҳия роҳбарӣ менамояд.<br />

                Мақомоти намояндагӣ ва иҷроияро дар воҳидҳои маъмурию ҳудудӣ раис сарварӣ мекунад.<br />

                Раиси Вилояти Мухтори Кӯҳистони Бадахшон, вилоят, шаҳри Душанбе, шаҳр ва ноҳияро Президент таъин ва озод мекунад ва ба тасдиқи Маҷлиси вакилони халқи дахлдор пешниҳод менамояд.<br />

                Раис дар назди мақомоти болоӣ ва Маҷлиси вакилони халқи дахлдор масъул аст.<br />

                Тартиби ташкил, ваколат ва фаъолияти мақомоти маҳаллии ҳокимияти давлатиро қонуни конститутсионӣ танзим менамояд.<br />

                Мақомоти худидоракунии шаҳрак ва деҳот Ҷамоат аст, ки тартиби ташкил, ваколат ва фаъолияти онро қонун танзим менамояд.<br />

                <p>Моддаи 79 </p>

                Мақомоти намояндагӣ ва раис дар доираи салоҳияти худ санадҳои ҳуқуқӣ қабул мекунанд, ки иҷрояшон дар он ҳудуд ҳатмист.<br />

                Дар сурати бо Конститутсия ва қонун мувофиқат накардани санадҳои мақомоти намояндагӣ ва раис онҳо аз тарафи мақомоти болоӣ, худи ин мақомот, раис ва ё суд бекор карда мешаванд.

                <p>Моддаи 80 </p>

                Дар сурати талаботи Конститутсия ва қонунро мунтазам иҷро накардани Маҷлиси вакилони халқи Вилояти Мухтори Кӯҳистони Бадахшон, вилоят, шаҳри Душанбе, шаҳр ва ноҳия Маҷлиси миллӣ метавонад онро пароканда намояд.
                <p className="text-center ">Боби ҳафтум</p>
                <p className="text-center">ВИЛОЯТИ МУХТОРИ КӮҲИСТОНИ БАДАХШОН</p>
                <p>Моддаи 81 </p>
                Вилояти Мухтори Кӯҳистони Бадахшон қисми таркибӣ ва ҷудонопазири Ҷумҳурии Тоҷикистон аст.
                Ҳудуди Вилояти Мухтори Кӯҳистони Бадахшон бе ризоияти Маҷлиси вакилони халқи вилоят тағйир дода намешавад.
                <p>Моддаи 82 </p>
                Маҷлиси вакилони халқи Вилояти Мухтори Кӯҳистони Бадахшон ҳуқуқи ташаббуси қонунгузорӣ дорад.
                <p>Моддаи 83 </p>
                Салоҳияти Вилояти Мухтори Кӯҳистони Бадахшон дар соҳаи иҷтимоӣ, иқтисодӣ, фарҳангӣ ва ваколатҳои дигари вилоятро қонуни конститутсионӣ танзим мекунад.
                <p className="text-center ">Боби ҳаштум</p>
                <p className="text-center">СУД</p>
                <p>Моддаи 84 </p>

                Ҳокимияти судӣ мустақил буда, аз номи давлат ва аз тарафи судяҳо амалӣ мегардад. Ҳокимияти судӣ ҳуқуқ, озодии инсону шаҳрванд, манфиати давлат, ташкилоту муассисаҳо, қонунияту адолатро ҳифз менамояд.<br />

                Адолати судиро Суди конститутсионӣ, Суди Олӣ, Суди Олии иқтисодӣ, Суди ҳарбӣ, Суди Вилояти Мухтори Кӯҳистони Бадахшон, судҳои вилоят, шаҳри Душанбе, шаҳр ва ноҳия, Суди иқтисодии Вилояти Мухтори Кӯҳистони Бадахшон, судҳои иқтисодии вилоят ва шаҳри Душанбе амалӣ мекунанд.<br />

                Тартиби таъсис, ташкил ва фаъолияти судро қонуни конститутсионӣ муайян мекунад.

                Муҳлати ваколати судяҳо 10 сол аст.<br />

                Таъсиси суди фавқулода манъ аст.<br />

                <p>Моддаи 85 </p>

                Ба вазифаи судяҳои Суди Олӣ, Суди Олии иқтисодӣ, судҳои Вилояти Мухтори Кӯҳистони Бадахшон, вилоят ва шаҳри Душанбе шахсе интихоб ё таъин мешавад, ки танҳо шаҳрвандии Ҷумҳурии Тоҷикистонро дошта бошад, дорои таҳсилоти олии ҳуқуқшиносӣ буда, синни ӯ аз 30 кам набошад ва ҳадди ақал 5 сол собиқаи кории судягӣ дошта бошад.<br />

                Ба вазифаи судяҳои судҳои шаҳр ва ноҳия, суди ҳарбӣ, судҳои иқтисодии Вилояти Мухтори Кӯҳистони Бадахшон, вилоят ва шаҳри Душанбе шахсе таъин мешавад, ки танҳо шаҳрвандии Ҷумҳурии Тоҷикистонро дошта бошад, дорои таҳсилоти олии ҳуқуқшиносӣ буда, синни ӯ аз 25 кам набошад ва ҳадди ақал 3 сол собиқаи кории касбӣ дошта бошад.
                Синни ниҳоии дар вазифаи судя фаъолият намуданро қонуни конститутсионӣ муайян менамояд.<br />

                Шахсе, ки бори аввал ба вазифаи судя таъин шудааст, дар вазъияти тантанавӣ савганд ёд мекунад.<br />

                <p>Моддаи 86 </p>

                Судяҳои Суди ҳарбӣ, судяҳои Суди Вилояти Мухтори Кӯҳистони Бадахшон, вилоят, шаҳри Душанбе, шаҳр ва ноҳия, судяҳои Суди иқтисодии Вилояти Мухтори Кӯҳистони Бадахшон, вилоят ва шаҳри Душанберо бо тартиби муқарраркардаи қонуни конститутсионӣ Президент таъин ва озод мекунад.<br />

                <p>Моддаи 87 </p>

                Судяҳо дар фаъолияти худ мустақил буда, танҳо ба Конститутсия ва қонун итоат мекунанд. Дахолат ба фаъолияти онҳо манъ аст.<br />

                <p>Моддаи 88 </p>

                Судяҳо парвандаҳоро ба таври дастҷамъӣ ва ё танҳо баррасӣ мекунанд.<br />

                Мурофиа ба тарзи мубоҳиса ва дар асоси баробарии тарафҳо сурат мегирад.<br />

                Мурофиа дар ҳамаи судҳо ба тарзи ошкоро мегузарад, ба истиснои мавридҳое, ки қонун муайян кардааст.<br />

                Мурофиа ба забони давлатӣ ва ё забони аксарияти аҳолии маҳал баргузор мегардад. Шахсоне, ки забони мурофиаро намедонанд, бо тарҷумон таъмин карда мешаванд.<br />

                <p>Моддаи 89 </p>

                Суди конститутсионӣ аз 7 нафар иборат буда, яке аз онҳо намояндаи Вилояти Мухтори Кӯҳистони Бадахшон мебошад.<br />

                Ба вазифаи судяи Суди конститутсионӣ шахсе интихоб мешавад, ки танҳо шаҳрвандии Ҷумҳурии Тоҷикистонро дошта бошад, дорои таҳсилоти олии ҳуқуқшиносӣ буда, синни ӯ аз 30 кам набошад ва ҳадди ақал 7 сол собиқаи кории касбӣ дошта бошад. Синни ниҳоии дар вазифаи судяи Суди конститутсионӣ фаъолият намуданро қонуни конститутсионӣ муайян менамояд.<br />

                Шахсе, ки бори аввал ба вазифаи судяи Суди конститутсионӣ интихоб шудааст, дар иҷлосияи Маҷлиси миллӣ савганд ёд мекунад.<br />

                Салоҳияти Суди конститутсионӣ:
                <ol>
                    <li>муайян намудани мувофиқати қонунҳо, санадҳои меъёрии ҳуқуқии якҷояи Маҷлиси миллӣ ва Маҷлиси намояндагон, Маҷлиси миллӣ, Маҷлиси намояндагон, Президент, Ҳукумат, Суди Олӣ, Суди Олии иқтисодӣ ва дигар мақомоти давлатию ҷамъиятӣ, шартномаҳои ба қувваи қонун надаромадаи Тоҷикистон ба Конститутсия;</li>
                    <li>ҳалли баҳсҳои байни мақомоти давлатӣ доир ба салоҳияти онҳо;</li>
                    <li>иҷрои ваколатҳои дигаре, ки Конститутсия ва қонунҳо муайян кардаанд.</li>

                </ol>

                Санадҳои Суди конститутсионӣ қатъист.

                <p>Моддаи 90 </p>

                Судя наметавонад вазифаи дигареро иҷро намояд, вакили мақомоти намояндагӣ, узви ҳизб ва созмонҳои сиёсӣ бошад, ба соҳибкорӣ машғул гардад, ба истиснои фаъолияти илмиву эҷодӣ ва омӯзгорӣ.

                <p>Моддаи 91 </p>

                Судя ҳуқуқи дахлнопазирӣ дорад. Ӯро бе ризоияти мақомоте, ки интихоб ё таъин кардааст, ҳабс кардан ва ба ҷавобгарии ҷиноятӣ кашидан мумкин нест. Судяро дастгир кардан мумкин нест, ба истиснои дастгир кардани ӯ ҳангоми содири ҷиноят.

                <p>Моддаи 92 </p>

                Ёрии ҳуқуқӣ дар тамоми марҳилаҳои тафтишот ва мурофиаи судӣ кафолат дода мешавад.

                Тарзи ташкил ва тартиби фаъолияти адвокатура ва дигар шаклҳои ёрии ҳуқуқиро қонун муайян мекунад.
                <p className="text-center ">Боби нуҳум</p>
                <p className="text-center">ПРОКУРАТУРА</p>
                <p>Моддаи 93 </p>
                Назорати риояи дақиқ ва иҷрои якхелаи қонунҳоро дар ҳудуди Тоҷикистон Прокурори генералӣ ва прокурорҳои тобеи он дар доираи ваколати худ татбиқ менамоянд.

                <p>Моддаи 94 </p>
                Низоми ягонаи марказонидашудаи прокуратураи Тоҷикистонро Прокурори генералӣ сарварӣ мекунад. Прокурори генералӣ дар назди Маҷлиси миллӣ ва Президент масъул аст.

                <p>Моддаи 95 </p>
                Прокурори генералии Тоҷикистон ба муҳлати 5 сол таъин мешавад.

                Прокурори генералӣ прокурорҳои тобеи худро таъин ва озод мекунад. Муҳлати ваколати прокурорҳо 5 сол аст.

                Фаъолият, салоҳият ва сохтори мақомоти прокуратураро қонуни конститутсионӣ танзим мекунад.

                <p>Моддаи 96 </p>
                Прокурори генералӣ ва прокурорҳои тобеи он бе дахолати дигар мақомоти давлатӣ ва шахсони мансабдор мустақилона дар асоси қонун фаъолият мекунанд.

                <p>Моддаи 97 </p>
                Прокурор наметавонад вазифаи дигареро иҷро намояд, вакили мақомоти намояндагӣ, узви ҳизб ва созмонҳои сиёсӣ бошад, ба соҳибкорӣ машғул шавад, ба истиснои фаъолияти илмиву эҷодӣ ва омӯзгорӣ.
                <p className="text-center ">Боби  даҳум</p>
                <p className="text-center">ТАРТИБИ ТАҒЙИРИ КОНСТИТУТСИЯ</p>
                <p>Моддаи 98 </p>
                Тағйиру иловаҳои Конститутсия бо роҳи раъйпурсии умумихалқӣ сурат мегирад.<br />

                Раъйпурсиро Президент ва ё Маҷлиси намояндагон бо тарафдории на камтар аз се ду ҳиссаи шумораи умумии вакилон таъин мекунанд.<br />

                <p>Моддаи 99 </p>
                Тағйиру иловаҳоро ба Конститутсия Президент ё ҳадди ақал аз се як ҳиссаи умумии аъзо ва вакилони Маҷлиси миллӣ ва Маҷлиси намояндагон пешниҳод мекунанд.

                Пешниҳоди тағйиру иловаҳои Конститутсия се моҳ пеш аз раъйпурсӣ дар матбуот чоп мешавад.

                <p>Моддаи 100 </p>
                Шакли идораи ҷумҳурӣ, тамомияти арзӣ, моҳияти демократӣ, ҳуқуқбунёдӣ, дунявӣ ва иҷтимоии давлат тағйирнопазиранд.<br />

                Муқаррароти интиқолӣ
                <ol>
                    <li>Тағйиру иловаҳо ба Конститутсияи Ҷумҳурии Тоҷикистон пас аз эълони натиҷаи раъйпурсии умумихалқӣ ва аз рӯзи интишори расмиаш эътибори ҳуқуқӣ пайдо мекунанд.</li>
                    <li> Қонунҳо ва дигар санадҳои меъёрию ҳуқуқие, ки то ворид намудани «Тағйиру иловаҳо ба Конститутсияи Ҷумҳурии Тоҷикистон» амал мекарданд, дар он қисме, ки ба тағйиру иловаҳо мухолиф нестанд, амал мекунанд.</li>
                    <li> Интихоби пай дар пайи Президент барои ду муҳлат, ки дар қисми чоруми моддаи 65 пешбинӣ шудааст, баъд аз ба охир расидани ваколати Президенти амалкунанда оғоз меёбад.</li>
                    <li>  Аъзои Маҷлиси миллӣ, вакилони Маҷлиси намояндагон ва аъзои Ҳукумат баъд аз эътибори ҳуқуқӣ пайдо кардани «Тағйиру иловаҳо ба Конститутсияи Ҷумҳурии Тоҷикистон» бо тартиби муқаррарнамудаи Конститутсия ва қонунҳои конститутсионӣ савганд ёд мекунанд.</li>

                </ol>
            </div>

            <Marquee />

        </div>

    )
}

export default Constitutions;